import { AuthStorage } from '../infrastructure/authStorage';

export class GetAccessTokenUseCase {
  private authStorage: AuthStorage;

  constructor() {
    this.authStorage = new AuthStorage();
  }

  execute(): string | null {
    return this.authStorage.getAccessToken();
  }
}

